var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29352 5.29471C4.68389 5.68443 5.31611 5.68445 5.7065 5.29476L9.49406 1.51403C9.77334 1.23525 9.77335 0.782728 9.49408 0.503935V0.503935C9.21549 0.225818 8.76431 0.22582 8.48572 0.503939L5.00032 3.98349L1.51429 0.503343C1.2357 0.225217 0.7845 0.225216 0.505903 0.503341V0.503341C0.226638 0.782131 0.226636 1.23464 0.505897 1.51343L4.29352 5.29471Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownArrow);
export default __webpack_public_path__ + "static/media/DropDownArrow.606a33f7e4655eec00f643c178d7a720.svg";
export { ForwardRef as ReactComponent };